export const filterPaymentMethods = (item) => {
  if (typeof item.type === 'string' && ['debit', 'credit'].indexOf(item.type.toLowerCase()) !== -1) {
    return false;
  }

  return true;
};
